import yup from '@/libs/yup.ts';

export default yup.object({
    fullname: yup.string().required('Name is required'),
    email: yup
        .string()
        .email('Invalid email address')
        .required('Email is required'),

    phone: yup.string().required('Phone number is required'),
    organisation_name: yup.string().required('Organization name is required'),
    organisation_website: yup
        .string()
        .transform((value) => (value?.trim() === '' ? undefined : value))
        .nullable()
        .test('is-valid-url', 'Please enter a valid URL', (value) => {
            if (!value) return true;

            const urlWithProtocol =
                value.startsWith('http://') || value.startsWith('https://')
                    ? value
                    : `http://${value}`;

            const domainPattern = /^[a-z0-9.-]+\.[a-z]{2,}$/i;

            try {
                const parsed = new URL(urlWithProtocol);
                return !!parsed.hostname && domainPattern.test(parsed.hostname);
            } catch {
                return false;
            }
        }),

    contact_consent: yup.boolean(),
    agree_terms: yup
        .boolean()
        .oneOf([true], 'You must agree to the Terms of Use')
        .required()
});
